export default "__VITE_ASSET__Cu6pAogB__"